import {
  Checkbox,
  Show,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { createDescription } from "../Modals/SetupSignupModal";
import { Discipline_GET } from "../../../Api/dto/Discipline_GET";
import { Discipline_POST_PUT } from "../../../Api/dto/Discipline_POST_PUT";
import { Role, useSessionState } from "../../../Session/SessionService";

export function DisciplineSelector(props: {
  eventStart: Date;
  disciplines: Discipline_GET[];
  onSelect: (selectedDisciplines: Discipline_GET[]) => void;
  selectLimit: number;
  initialSelections: Discipline_GET[];
  showDeleted?: boolean;
  preventSelectionOfClosedSignup?: boolean;
}) {
  const [selectedDisciplines, setSelectedDisciplines] = useState<
    Discipline_GET[]
  >(props.initialSelections);

  const session = useSessionState();
  session.getUserMode();

  useEffect(() => {
    setSelectedDisciplines(props.initialSelections);
  }, [props.initialSelections]);

  const handleDisciplineToggle = (discipline: Discipline_GET) => {
    const isSelected = selectedDisciplines
      .map((d) => d.id)
      .includes(discipline.id);
    if (isSelected) {
      setSelectedDisciplines((old) => {
        const newArray = old.filter((d) => d.id !== discipline.id);
        props.onSelect(newArray);
        return newArray;
      });
    } else if (selectedDisciplines.length < props.selectLimit) {
      setSelectedDisciplines((old) => {
        const newArray = [
          ...old.filter((d) => d.id !== discipline.id),
          discipline,
        ];
        props.onSelect(newArray);
        return newArray;
      });
    } else {
      setSelectedDisciplines([discipline]);
      props.onSelect([discipline]);
    }
  };

  return (
    <>
      <Show above={"sm"}>
        <Stack direction="column">
          <Table size="sm">
            <Thead>
              <Tr key={"header"}>
                <Th key={"name"}>Namn</Th>
                <Th key={"description"}>Beskrivning</Th>
                <Th key={"cost"}>Anmälan Kostnad</Th>
                <Th key={"open"}>Anmälan Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {props.disciplines
                .filter((d) => props.showDeleted || !d.deleted)
                .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
                .map((discipline, i) => {
                  return (
                    <Tr
                      key={discipline.id + "ROW"}
                      background={discipline.id < 0 ? "green.100" : "white"}
                      textColor={"gray.600"}
                      textDecoration={
                        discipline.deleted ? "line-through" : undefined
                      }
                    >
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        key={discipline.id + "cellname"}
                      >
                        <Checkbox
                          borderColor={"gray.500"}
                          key={discipline.id}
                          isDisabled={shouldDisableSelection(
                            props.preventSelectionOfClosedSignup ?? false,
                            discipline,
                            session.getUserMode()
                          )}
                          checked={selectedDisciplines
                            .map((d) => d.id)
                            .includes(discipline.id)}
                          isChecked={selectedDisciplines
                            .map((d) => d.id)
                            .includes(discipline.id)}
                          onChange={() => handleDisciplineToggle(discipline)}
                        >
                          <Text
                            textDecoration={
                              discipline.deleted ? "line-through" : undefined
                            }
                          >
                            {discipline.name}
                          </Text>
                        </Checkbox>
                      </Td>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        key={discipline.id + "celldescription"}
                      >
                        {getDescription(props.eventStart, discipline)}
                      </Td>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        width={"20%"}
                        key={"cellcost" + discipline.id}
                      >
                        {`${discipline.signupCostInSek}\xa0kr/person`}{" "}
                      </Td>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        width={"20%"}
                        textColor={
                          isSignupOpen(
                            discipline.signupOpenTime,
                            discipline.signupClosedTime
                          )
                            ? "black"
                            : "red"
                        }
                        key={"celltime" + discipline.id}
                      >
                        <SignupTimeInfo 
                          signupOpeningDate={discipline.signupOpenTime}
                          signupClosedDate={discipline.signupClosedTime}
                        />
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Stack>
      </Show>
      <Show below={"sm"}>
        <Stack direction="column">
          <Table size="sm">
            <Thead>
              <Tr key={"header"}>
                <Th key={"name"}>Namn</Th>
                <Th key={"description"}>Beskrivning</Th>
                <Th key={"anmalan"}>Anmälan</Th>
                {/*
                  <Th key={"cost"}>Kostnad</Th>
                  <Th key={"open"}>Anmälan öppen till</Th>
                  */}
              </Tr>
            </Thead>
            <Tbody>
              {props.disciplines
                .filter((d) => props.showDeleted || !d.deleted)
                .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
                .map((discipline, i) => {
                  return (
                    <Tr key={discipline.id + "ROW"}>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        key={discipline.id + "cellname"}
                      >
                        <Checkbox
                          key={discipline.id}
                          borderColor={"gray.500"}
                          checked={selectedDisciplines
                            .map((d) => d.id)
                            .includes(discipline.id)}
                          isChecked={selectedDisciplines
                            .map((d) => d.id)
                            .includes(discipline.id)}
                          onChange={() => handleDisciplineToggle(discipline)}
                          isDisabled={shouldDisableSelection(
                            props.preventSelectionOfClosedSignup ?? false,
                            discipline,
                            session.getUserMode()
                          )}
                        >
                          {discipline.name}
                        </Checkbox>
                      </Td>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        key={discipline.id + "celldescription"}
                      >
                        {getDescription(props.eventStart, discipline)}
                      </Td>
                      <Td
                        paddingTop={"20px"}
                        paddingBottom={"20px"}
                        width={"20%"}
                        key={"cellcost" + discipline.id}
                      >
                        <VStack>
                          <Text>
                            {`${discipline.signupCostInSek}\xa0kr/person`}{" "}
                          </Text>
                        <SignupTimeInfo 
                          signupOpeningDate={discipline.signupOpenTime}
                          signupClosedDate={discipline.signupClosedTime}
                            textColor={
                              isSignupOpen(
                                discipline.signupOpenTime,
                                discipline.signupClosedTime
                              )
                                ? "black"
                                : "red"
                            }
                        />
                        </VStack>
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Stack>
      </Show>
    </>
  );
}

export function isSignupOpen(
  signupOpeningDateEpoch: number | null,
  signupClosedDateEpoch: number | null
) {
  const signup = signupOpeningInfo(
    signupOpeningDateEpoch,
    signupClosedDateEpoch
  );
  return signup.isOpen;
}

export function signupOpeningInfo(
  signupOpeningDateEpoch: number | null,
  signupClosedDateEpoch: number | null
) {
  const now = nowEpoch();

  const notReachedOpeningTime =
    signupOpeningDateEpoch == null || signupOpeningDateEpoch > now;
  const notReachedClosingTime =
    signupClosedDateEpoch == null || signupClosedDateEpoch > now;

  const isOpen = !notReachedOpeningTime && notReachedClosingTime;
  const willClose = isOpen && signupClosedDateEpoch != null;
  const willOpen = notReachedOpeningTime && signupOpeningDateEpoch != null;

  return { isOpen, willOpen, willClose };
}

function nowEpoch() {
  return new Date(Date.now()).getTime();
}

export function SignupTimeInfo({
  signupOpeningDate,
  signupClosedDate,
  textColor
}: {
  signupOpeningDate: number | null;
  signupClosedDate: number | null;
  textColor?: string;
}) {
  const now = nowEpoch();
  const { isOpen, willOpen, willClose } = signupOpeningInfo(
    signupOpeningDate,
    signupClosedDate
  );

  var countDownRow = "";
  var dateRow = "";

  if (willOpen) {
    countDownRow = "Öppnar";
    const isToday = new Date(signupOpeningDate!).toDateString() === new Date(now).toDateString();
    if (isToday) {
      dateRow = `${new Date(signupOpeningDate!).toLocaleString("sv-SE", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    }
    else {
      dateRow = `${new Date(signupOpeningDate!).toLocaleString("sv-SE", {
        month: "short",
        day: "numeric",
      })}`;
    }
  } else if (willClose) {
    countDownRow = "Stänger";
    const isToday = new Date(signupClosedDate!).toDateString() === new Date(now).toDateString();
    if (isToday) {
      dateRow = `${new Date(signupClosedDate!).toLocaleString("sv-SE", {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    }
    else {
      dateRow = `${new Date(signupClosedDate!).toLocaleString("sv-SE", {
        month: "short",
        day: "numeric",
      })}`;
    }
  } else if (isOpen) {
    return <Text textColor={textColor}>Öppen</Text>;
  } else {
    return <Text textColor={textColor}>Stängd</Text>;
  }

  return (<VStack>
    <Text textColor={textColor}>{countDownRow}</Text>
    <Text textColor={textColor}>{dateRow}</Text>
  </VStack>);

}

export function getSignupTimeDisplayInfo(
  signupOpeningDate: number | null,
  signupClosedDate: number | null
) {
  const now = nowEpoch();
  const { isOpen, willOpen, willClose } = signupOpeningInfo(
    signupOpeningDate,
    signupClosedDate
  );

  if (willOpen) {
    return `Öppnar\xa0om ${convertMilliseconds(signupOpeningDate! - now)}`;
  } else if (willClose) {
    return `Stänger\xa0om ${convertMilliseconds(signupClosedDate! - now)}`;
  } else if (isOpen) {
    return "Öppen";
  } else {
    return "Stängd";
  }
}

function convertMilliseconds(ms: number) {
  const msInSecond = 1000;
  const msInMinute = msInSecond * 60;
  const msInHour = msInMinute * 60;
  const msInDay = msInHour * 24;
  const msInVecka = msInDay * 7;
  if (ms / msInVecka >= 2) {
    return `${Math.floor(ms / msInVecka)}\xa0veckor`;
  }
  if (ms / msInDay >= 2) {
    return `${Math.floor(ms / msInDay)}\xa0dagar`;
  }
  if (ms / msInHour >= 2) {
    return `${Math.floor(ms / msInHour)}\xa0timmar`;
  }
  return `${Math.floor(ms / msInMinute)}\xa0minuter`;
}

function getDescription(eventStart: Date, discipline: Discipline_POST_PUT) {
  return createDescription(
    discipline.description,
    discipline.minAge,
    discipline.maxAge,
    eventStart
  );
}

function shouldDisableSelection(
  restrictSelectionForClosedSignups: boolean,
  discipline: Discipline_GET,
  role: Role | null
) {
  const signupOpen = isSignupOpen(
    discipline.signupOpenTime,
    discipline.signupClosedTime
  );

  if (signupOpen || !restrictSelectionForClosedSignups) {
    return false;
  }

  const isTeamSignup = discipline.groupSize != null && discipline.groupSize > 1;
  const isAdminOrHigher =
    role != null && [Role.ADMIN, Role.DEVELOPER].includes(role);
  const isOfficialHigher =
    role != null && [Role.OFFICIAL, Role.ADMIN, Role.DEVELOPER].includes(role);

  const hasAuthorityToOverride =
    isAdminOrHigher || (isOfficialHigher && !isTeamSignup);
  return !hasAuthorityToOverride;
}
